"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("./../../../_util/useConfig"));
var NodeLink = function (props) {
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var img = props.img, content = props.content, href = props.href;
    return (react_1.default.createElement("a", { className: "".concat(classPrefix, "-link"), href: href, target: "_blank", rel: "noreferrer" },
        react_1.default.createElement("img", { src: img, alt: "" }),
        content));
};
exports.default = NodeLink;
//# sourceMappingURL=Node.js.map